var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('v-content',{staticClass:"grey_vlight"},[_c('transition',{attrs:{"name":"toolbar-anim"}},[(_vm.showToolbar)?_c('Toolbar'):_vm._e()],1),_c('transition',{attrs:{"name":"router-anim"}},[_c('router-view')],1),_c('transition',{attrs:{"name":"bottom-nav-anim"}},[(_vm.showBottomNav)?_c('bottomNav'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }